import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

// @ts-ignore
import {Subscription} from 'rxjs';
import {DiversityFunnelStages, DiversityOptions, FunnelSelectionDetails} from '../../../model';
import {ClientApiService, DiversityMetrics, DiversityMetricsSegmented} from '../client-api.service';
import * as dayjs from 'dayjs';
import {TranslateService} from '@ngx-translate/core';
import {DiversityInsightService} from './service/diversity-insight.service';

@Component({
  selector: 'diversity-insight',
  templateUrl: './diversity-insight.component.html',
  styleUrls: ['./diversity-insight.component.scss']
})
export class DiversityInsightComponent implements OnInit {

  orderCount: number;
  candidateCount: number;
  selectedDateRange: { endDate; startDate };

  private paramsSub: Subscription;
  public insufficientData: boolean;

  metrics: DiversityMetrics | DiversityMetricsSegmented[] = null;

  options = DiversityOptions;
  // tslint:disable-next-line:variable-name
  _selectedFunnelStage = null;
  funnelSelectionDetails: FunnelSelectionDetails = null;

  constructor(
    private route: ActivatedRoute,
    private Api: ClientApiService,
    private translate: TranslateService,
    private diversityInsightService: DiversityInsightService) {
    this.selectedDateRange = {
      startDate: dayjs().subtract(3, 'M').toDate(),
      endDate: dayjs().toDate()
    };
    this.paramsSub = this.route.paramMap
      .subscribe(params => {
        const selected = params.get('view');
        this.diversityInsightService.selectedDiversityTab = {name: selected, data: []};
      });
  }

  ngOnInit() {
    this.updateMetrics();
  }

  updateMetrics() {
      this.Api.readDiversityMetricsByYearAndQuarter()
        .subscribe((metrics => {
          this.metrics = metrics.slice(1, metrics.length);
        }));
  }

  get selected() {
    return this.diversityInsightService.selectedDiversityTab;
  }

  public get DiversityOptions() {
    return DiversityOptions;
  }

  public get DiversityFunnelStages() {
    return DiversityFunnelStages;
  }

  public funnelStageClicked(event, funnelStage) {
    this._selectedFunnelStage = funnelStage;
    const clickedLabel = event.target.textContent;
    if (!clickedLabel.toLowerCase().includes(this.diversityInsightService.selectedDiversityTab.name)) {
      this.diversityInsightService.hiddenDemographics = [];
    }
  }

  public setFunnelSelectionDetails(event) {
    this.funnelSelectionDetails = event;
  }

  public setCandidateCount(event) {
    this.candidateCount = event;
  }

  public setOrderCount(event) {
    this.orderCount = event;
  }

  get selectedFunnelStage(): string {
    return this.funnelSelectionDetails !== null ? this.funnelSelectionDetails.selectedFunnelStage : null;
  }

  clearSelectedFunnelStage() {
    this.funnelSelectionDetails = null;
    this._selectedFunnelStage = null;
  }

  getYearQuarterString() {
    if (this.funnelSelectionDetails === null) {
      return null;
    }
    return `${this.funnelSelectionDetails.selectedYear} ${this.funnelSelectionDetails.selectedQuarter}`;
  }
}

